import React, { Component } from "react";
// import Carousel from "react-spring-3d-carousel";
import uuidv4 from "uuid";
import { config } from "react-spring";
import Carousel from "./carousel";
export default class SlideComponent extends Component {

  render() {
    
  const slides = [
    {
      id: 1,
      title: 'First',
      subtitle: 'slide',
      description: 'Praesent ac sem eget est.',
      image: './slideimages/1.png',
    },
    {
      id: 2,
      title: 'Second',
      subtitle: 'slide',
      description: 'Praesent ac sem eget est.',
      image: './slideimages/2.png',
    },
    {
      id: 3,
      title: 'Third',
      subtitle: 'slide',
      description: 'Praesent ac sem eget est.',
      image: './slideimages/3.png',
    },
  ];
    return (
      <div className="w-4/5 h-[500px] my-0 mx-auto relative">
        <Carousel slides={slides} isPageBackground = {true} />;
      </div>
    );
  }
}
